import xss from 'xss';
import { attributesToString, getAttributesFromString } from './HtmlUtils';

const transform: { [key: string]: { tag: string; class?: string } } = {
	em: { tag: 'i' },
	strong: { tag: 'b' },
	strike: { tag: 's' },
	del: { tag: 's' },
	ins: { tag: 'u' },
	h1: { tag: 'h2', class: 'text:h2' },
	h2: { tag: 'h3', class: 'text:h3' },
	h3: { tag: 'h4', class: 'text:h4' },
	h4: { tag: 'h5', class: 'text:h5' },
	h5: { tag: 'h6', class: 'text:h6' },
	h6: { tag: 'b', class: 'text:md' },
	// p: { tag: 'p', class: 'text:body' },
	blockquote: { tag: 'blockquote', class: 'text:sm' },
	figcaption: { tag: 'figcaption', class: 'text:xs' }
};

const protocols = /^(https?|\/|#|tel:|mailto:|\.\.?\/)/;

export const CleanHTML = (text: string) => {
	return xss(text, {
		css: {
			whiteList: {
				'text-align': 'right'
			}
		},
		whiteList: {
			q: ['class', 'style'],
			blockquote: ['class', 'style'],
			cite: ['class', 'style'],
			img: ['class', 'src', 'alt', 'title', 'width', 'height', 'loading', 'style'],
			figcaption: ['class', 'style'],
			figure: ['class', 'style'],
			h2: ['class', 'style'],
			h3: ['class', 'style'],
			h4: ['class', 'style'],
			h5: ['class', 'style'],
			p: ['class', 'style'],
			span: ['class', 'style'],
			a: ['target', 'href', 'title', 'name', 'class', 'style'],
			table: ['class', 'width', 'border', 'align', 'valign', 'style'],
			tbody: ['align', 'valign'],
			td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
			tfoot: ['align', 'valign'],
			th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
			thead: ['align', 'valign'],
			tr: ['rowspan', 'align', 'valign'],
			col: ['align', 'valign', 'span', 'width'],
			colgroup: ['align', 'valign', 'span', 'width'],
			ol: ['style'],
			ul: ['style'],
			li: ['style'],
			i: ['style'],
			s: ['style'],
			b: ['style'],
			u: ['style'],
			br: []
		},
		onTag: (tag, html, options) => {
			if (transform[tag]) {
				const { tag: newTag, class: newClass } = transform[tag];
				if (options.isClosing) {
					return `</${newTag}>`;
				} else {
					const attributes = getAttributesFromString(html);

					if (!attributes.class || !attributes.class.includes('text:')) {
						attributes.class = `${attributes.class ?? ''} ${newClass}`.trim();
					}

					if (!attributes.class || attributes.class === 'undefined') delete attributes.class;

					const str = attributesToString(attributes);

					if (!str) return `<${newTag}>`;

					return `<${newTag} ${str}>`;
				}
			}
		},
		safeAttrValue: (_, name, value) => {
			// value = friendlyAttrValue(value);
			value = value.trim();

			if (name === 'class') {
				const classes = value.split(' ');
				const allowedClasses = classes.filter(
					(c) => c.startsWith('text:') || c.startsWith('button:') || c.startsWith('layout:')
				);
				value = allowedClasses.join(' ');
			} else if (name === 'href' || name === 'src' || name === 'cite') {
				if (value.endsWith('#cookie')) return 'javascript:window.CookieConsent?.renew?.();';
				/* Attributes to test schemes */
				if (!protocols.test(value) && value !== 'javascript:window.CookieConsent?.renew?.();')
					return '';
			}

			// value = escapeAttrValue(value);
			return value;
		},
		stripIgnoreTag: true,
		stripIgnoreTagBody: ['script']
	});
};
